import * as React from "react";
import type { SVGProps } from "react";
const SvgThermometer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.33 14.46a5.03 5.03 0 0 0-1.33-1.5V5c0-1.65-1.35-3-3-3S9 3.35 9 5v7.96c-.9.67-1.54 1.61-1.83 2.71-.35 1.29-.17 2.64.5 3.79.93 1.6 2.61 2.5 4.34 2.5.85 0 1.71-.21 2.49-.67a5.002 5.002 0 0 0 1.83-6.83ZM12 4c.55 0 1 .45 1 1v3h-2V5c0-.55.45-1 1-1Zm1.5 15.56c-1.43.83-3.27.33-4.1-1.1-.4-.69-.51-1.5-.3-2.28.21-.77.7-1.42 1.4-1.82.31-.18.5-.51.5-.87v-3.5h2v3.5c0 .36.19.69.5.87.46.26.84.64 1.1 1.1.83 1.43.33 3.27-1.1 4.1Z"
    />
  </svg>
);
export default SvgThermometer;
